import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './Welcome.css';



const Welcome = () => {
    return (
        <>
            <div
                className="rectangle position-relative"
                
            >
                <div className="welcome-section container mt-md-5 pt-lg-5 mt-3 mb-md-5">

                    <div className="row">
                        <div className="col-md-12">
                            <h1 className="mt-md-5 mt-4 text-center headings welcome-heading">WELCOME TO <span>BLUEBERRY TRAVEL </span></h1>
                        </div>
                        <div className="col-md-12 mt-md-2">
                            <p className="text-center subtext mb-1 mb-md-3">Redefining Global Business Travel</p>
                        </div>
                        <div className="col-md-2"></div>
                        <div className="col-md-8 ms-lg-3">
                            <div className="d-flex justify-content-center">
                                <p className="text-center  firstP">
                                    Where clients become partners With <span className="fw-bold text-dark">over a decade of experience,</span> we at Blueberry Travel pride ourselves on delivering quality, value, safety, and sustainability to our clients and their businesses. We integrate effortlessly with your team, boosting your corporate travel program with agility and efficiency.</p>
                            </div>
                        </div>
                        <div className="col-md-2"></div>
                        <div className="col-md-12">
                            <span className="fs6 fw-bold text-center d-flex justify-content-center  thats-fs">That’s how we keep BBT differentiated...</span>
                            <div className="d-flex flex-column justify-content-center">
                                <div className="bgimage-blueberry d-flex justify-content-center">
                                    <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/BLUEBERRY.png" alt="" loading="lazy"  />
                                </div>
                                <p className="bgimage-text p text-center pb-3 bottom-75 mb-5 position-absolute start-0 end-0">We have customized travel management solutions that excel in customer service,<br /> leverage innovative travel technology, and demonstrate a strong return on investment.
                                </p>
                                <div className="explore-btn d-flex justify-content-center">
                                    <a
                                        href="/corporate-travel"
                                        className="bg-transparent border-0 text-decoration-none btn-light bg-transparent fs4 explore-btn fw-bold border-0 outline-0 mt-0"
                                        role="button"
                                    >
                                        Explore More...
                                    </a>
                                </div>

                            </div>
                        </div>

                    </div>

                    <div className="d-flex justify-content-center mt-2">
                        <a href="/corporate-travel">
                        <button className="arrow-btn border-0 shadow"> <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/Right%20arrow.png" alt="right-arrow" loading="lazy"  /></button>
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Welcome